export const statusPageOptions = {
  production: 'https://status.app.planzer.ch/',
  nonProduction: 'https://status.t7p.io/',
};
